export function ProjectsService ({socket}) {

    const events = new andy.EventManager();

    const dataset = new andy.Dataset('andy.projects'); 

    return  {
        dataset,
        on: events.addEventListener
    }
}
